var lg_6710CDAL01G = {
    name: "6710CDAL01G",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,213,123,234,136],
        },
        {
            function: "KEY_OPEN",
            name: "KEY_OPEN",
            icon: "KEY_OPEN",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,218,235,117,136],
        },
        {
            // function: "cd-dvd",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,175,250,170,136],
        },
        {
            function: "band",
            name: "band",
            icon: "band",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,186,221,118,136],
        },
        {
            function: "KEY_AUX",
            name: "KEY_AUX",
            icon: "KEY_AUX",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,187,245,170,136],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,191,117,86,136],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,223,109,86,136],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,175,189,86,136],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,239,107,86,136],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,183,187,86,136],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,215,183,86,136],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,171,223,86,136],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,247,106,214,136],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,187,186,214,136],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,173,222,214,136],
        },
        {
            function: "KEY_SLEEP",
            name: "KEY_SLEEP",
            icon: "KEY_SLEEP",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,223,86,171,136],
        },
        {
            function: "KEY_AUDIO",
            name: "KEY_AUDIO",
            icon: "KEY_AUDIO",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,253,170,173,136],
        },
        {
            function: "sound",
            name: "sound",
            icon: "sound",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,190,218,173,136],
        },
        {
            function: "s-title",
            name: "s-title",
            icon: "s-title",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,173,183,109,136],
        },
        {
            function: "KEY_ENTER",
            name: "KEY_ENTER",
            icon: "KEY_ENTER",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,219,107,109,136],
        },
        {
            function: "KEY_SETUP",
            name: "KEY_SETUP",
            icon: "KEY_SETUP",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,183,109,173,136],
        },
        {
            function: "display",
            name: "display",
            icon: "display",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,175,110,173,136],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,238,213,173,136],
        },
        {
            function: "KEY_TITLE",
            name: "KEY_TITLE",
            icon: "KEY_TITLE",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,170,219,237,136],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,171,183,173,136],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,215,107,173,136],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,246,213,109,136],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,187,109,109,136],
        },
        {
            function: "KEY_KPPLUS",
            name: "KEY_KPPLUS",
            icon: "KEY_KPPLUS",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,174,253,106,136],
        },
        {
            function: "KEY_KPMINUS",
            name: "KEY_KPMINUS",
            icon: "KEY_KPMINUS",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,221,237,106,136],
        },
        {
            function: "KEY_REWIND",
            name: "KEY_REWIND",
            icon: "KEY_REWIND",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,189,109,93,136],
        },
        {
            function: "KEY_FORWARD",
            name: "KEY_FORWARD",
            icon: "KEY_FORWARD",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,221,107,93,136],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,171,127,106,136],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,214,247,106,136],
        },
        {
            function: "<<<",
            name: "<<<",
            icon: "<<<",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,215,238,170,136],
        },
        {
            function: ">>>",
            name: ">>>",
            icon: ">>>",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,171,254,170,136],
        },
        {
            function: "KEY_STOP",
            name: "KEY_STOP",
            icon: "KEY_STOP",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,183,246,170,136],
        },
        {
            function: "KEY_PAUSE",
            name: "KEY_PAUSE",
            icon: "KEY_PAUSE",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,170,239,214,136],
        },
        {
            function: "KEY_PLAY",
            name: "KEY_PLAY",
            icon: "KEY_PLAY",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,239,214,170,136],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,170,191,234,136],
        },
        {
            function: "program",
            name: "program",
            icon: "program",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,181,221,214,136],
        },
        {
            function: "KEY_CLEAR",
            name: "KEY_CLEAR",
            icon: "KEY_CLEAR",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,250,213,93,136],
        },
        {
            function: "KEY_AGAIN",
            name: "KEY_AGAIN",
            icon: "KEY_AGAIN",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,213,219,214,136],
        },
        {
            function: "repeata-b",
            name: "repeata-b",
            icon: "repeata-b",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,181,182,237,136],
        },
        {
            function: "marker",
            name: "marker",
            icon: "marker",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,237,106,221,136],
        },
        {
            function: "KEY_SEARCH",
            name: "KEY_SEARCH",
            icon: "KEY_SEARCH",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,174,183,93,136],
        },
        {
            function: "KEY_ANGLE",
            name: "KEY_ANGLE",
            icon: "KEY_ANGLE",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,235,106,237,136],
        },
        {
            function: "KEY_ZOOM",
            name: "KEY_ZOOM",
            icon: "KEY_ZOOM",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,213,181,237,136],
        },
        {
            function: "rds",
            name: "rds",
            icon: "rds",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,253,106,174,136],
        },
        {
            function: "pty",
            name: "pty",
            icon: "pty",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,189,93,94,136],
        },
        {
            function: "pty-search",
            name: "pty-search",
            icon: "pty-search",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,186,189,122,136],
        },
        {
            function: "dimmer",
            name: "dimmer",
            icon: "dimmer",
            command: [68,0,4,51,2,47,2,51,2,145,6,200,17,182,17,33,2,143,183,58,223,91,213,109,246,136],
        },
    ]
}
export default lg_6710CDAL01G